export const basePath = 'https://search-api-openedition-org.wikipedialibrary.idm.oclc.org';

export const piwikConfig = {
  url: 'https://pk.labocleo.org',
  siteId: 12,
  clientTrackerName: 'pk.js',
  serverTrackerName: 'pk.php'
};



// WEBPACK FOOTER //
// ./src/config.js